<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" v-show="false" type="primary" v-hasPermi="['system:menu:add']">新增</a-button>
      <a-button @click="expandChange()">展开/折叠</a-button>
    </div>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="菜单名称">
              <a-input placeholder="请输入" v-model="queryParams.menuName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" v-model="queryParams.status">
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="0">停用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">

        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="menuList"
          :row-selection="rowSelection"
          row-key="menuId"
          :key="new Date().getTime()"
          v-if="menuList"
          :defaultExpandAllRows="isExpandAll"
          :expandIcon="expandIcon"
          :pagination="false"
        >
          <!-- 插槽指向菜单图标 -->
          <span slot="icon" slot-scope="text">
            <ls-icon :type="text"/>
          </span>
          <!-- 插槽指向状态 -->
          <span slot="status" slot-scope="text">
            <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
          </span>
          <!-- 更多选择 -->
          <!-- <span slot="action" slot-scope="text, record">
            <a @click="$refs.createModal.show(record)" v-hasPermi="['system:menu:edit']">编辑</a>
            <a-divider type="vertical" />
            <a @click="$refs.createModal.show({parentId:record.menuId})" v-hasPermi="['system:menu:add']">新增</a>
            <a-divider type="vertical" />
            <a @click="handleDelete(record)" v-hasPermi="['system:menu:remove']">删除</a>
          </span> -->
        </a-table>
        <!-- 创建/编辑菜单,单独封装了组件 -->
        <create-form
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { delMenu, listMenu } from '@/api/system/menu'
import CreateForm from './components/CreateForm'
import all from '@/core/icons'
const statusMap = {
  0: {
    status: 'default',
    text: '停用'
  },
  1: {
    status: 'processing',
    text: '正常'
  }
}
export default {
  name: 'Menu',
  components: {
    CreateForm
  },
  data () {
    return {
      // 图标选择器
      all,
      tableLoading: false,
      // 表格树数据:
      menuList: [],
      // 表格属性
      columns: [
        {
          title: '菜单名称',
          dataIndex: 'menuName',
          scopedSlots: { customRender: 'menuName' },
          width: 250
        },
        {
          title: '图标',
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
          width: 50
        },
        {
          title: '排序',
          dataIndex: 'orderNum',
          width: 50
        },
        {
          title: '权限标识',
          dataIndex: 'perms',
          width: 200,
          ellipsis: true
        },
        {
          title: '组件路径',
          dataIndex: 'component',
          width: 200,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 80
        },
        {
          title: '创建时间',
          width: 150,
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   width: 150,
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        menuName: undefined,
        status: undefined
      },
      // 是否展开所有
      isExpandAll: false,
      copyAllMenuIds: [],
      defaultExpandedRowKeys: [1, 2, 3, 4, 5],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  created () {
    this.getList()
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    /** 查询菜单列表 */
    getList () {
      this.tableLoading = true
      listMenu(this.queryParams).then(response => {
        this.copyAllMenuIds = response.data.map((item) => { return item.menuId + "" });
        this.menuList = this.handleTree(response.data, 'menuId')
        this.tableLoading = false
      })
    },
    /** 转换菜单数据结构 */
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.menuId,
        label: node.menuName,
        children: node.children
      }
    },
    /** 图标替换 */
    expandIcon (props) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return (
              <span
                class="table-icon"
                onClick={(e) => {
                  props.onExpand(props.record, e);
                }}
              >
                <a-icon type="down" />
              </span>
            );
          } else {
            return (
              <span
                class="table-icon"
                onClick={(e) => {
                  props.onExpand(props.record, e);
                }}
              >
                <a-icon type="right" />
              </span>
            );
          }
        } else {
          return <span class="mr19"></span>;
        }
    },
    /** 展开/关闭 */
    expandChange () {
      this.isExpandAll = !this.isExpandAll;
      this.$forceUpdate();
    },
    /** 查询菜单下拉树结构 */
    getTreeselect () {
      listMenu().then(response => {
        this.menuOptions = []
        const menu = { menuId: 0, menuName: '主类目', children: [] }
        menu.children = this.handleTree(response.data, 'menuId')
        this.menuOptions.push(menu)
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        menuName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const menuId = row.menuId
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 菜单编号为${menuId}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delMenu(menuId).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.getList()
    }
  }
}
</script>
<style scoped>
  .table-icon {
    margin-right: 7px;
    color: #87909f;
    font-size: 12px;
    cursor: pointer;
  }
  .mr19 {
    margin-right: 19px
  }
</style>
